import { render, staticRenderFns } from "./Layers.vue?vue&type=template&id=2614345a&scoped=true"
import script from "./Layers.vue?vue&type=script&lang=ts&setup=true"
export * from "./Layers.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./Layers.vue?vue&type=style&index=0&id=2614345a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2614345a",
  null
  
)

export default component.exports